function overlayScrollbar() {
    const root = document.documentElement;
    const viewport = document.querySelector('.gh-viewport');
    const scrollport = document.querySelector('[data-scrollport]');

    if (!viewport || !scrollport) return;

    const scrollbar = document.createElement('div');
    const thumb = document.createElement('div');
    let animationFrame = null;
    let dragState = null;

    scrollbar.className = 'gh-overlay-scrollbar';
    scrollbar.setAttribute('aria-hidden', 'true');
    thumb.className = 'gh-overlay-scrollbar-thumb';
    scrollbar.appendChild(thumb);
    viewport.appendChild(scrollbar);
    root.classList.add('has-overlay-scrollbar');

    function update() {
        animationFrame = null;

        const viewportRect = viewport.getBoundingClientRect();
        const scrollportRect = scrollport.getBoundingClientRect();
        const trackHeight = scrollport.clientHeight;
        const maximumScroll = scrollport.scrollHeight - trackHeight;
        const scrollIsLocked = getComputedStyle(scrollport).overflowY === 'hidden';

        scrollbar.style.top = `${scrollportRect.top - viewportRect.top}px`;
        scrollbar.style.height = `${trackHeight}px`;
        scrollbar.hidden = maximumScroll <= 1 || scrollIsLocked;

        if (scrollbar.hidden) return;

        const thumbHeight = Math.max(
            48,
            Math.round(trackHeight * trackHeight / scrollport.scrollHeight)
        );
        const maximumThumbTop = trackHeight - thumbHeight;
        const thumbTop = maximumScroll > 0
            ? Math.round(scrollport.scrollTop / maximumScroll * maximumThumbTop)
            : 0;

        thumb.style.height = `${thumbHeight}px`;
        thumb.style.transform = `translateY(${thumbTop}px)`;
    }

    function scheduleUpdate() {
        if (animationFrame === null) {
            animationFrame = requestAnimationFrame(update);
        }
    }

    function stopDragging(event) {
        if (!dragState || event.pointerId !== dragState.pointerId) return;

        if (thumb.hasPointerCapture(event.pointerId)) {
            thumb.releasePointerCapture(event.pointerId);
        }
        dragState = null;
        scrollbar.classList.remove('is-dragging');
    }

    thumb.addEventListener('pointerdown', function (event) {
        const maximumScroll = scrollport.scrollHeight - scrollport.clientHeight;
        const maximumThumbTop = scrollbar.clientHeight - thumb.offsetHeight;

        if (maximumScroll <= 0 || maximumThumbTop <= 0) return;

        dragState = {
            pointerId: event.pointerId,
            pointerY: event.clientY,
            scrollTop: scrollport.scrollTop,
            scrollPerPixel: maximumScroll / maximumThumbTop,
        };
        scrollbar.classList.add('is-dragging');
        thumb.setPointerCapture(event.pointerId);
        event.preventDefault();
    });

    thumb.addEventListener('pointermove', function (event) {
        if (!dragState || event.pointerId !== dragState.pointerId) return;

        scrollport.scrollTop = dragState.scrollTop
            + (event.clientY - dragState.pointerY) * dragState.scrollPerPixel;
    });
    thumb.addEventListener('pointerup', stopDragging);
    thumb.addEventListener('pointercancel', stopDragging);

    scrollbar.addEventListener('pointerdown', function (event) {
        if (event.target === thumb) return;

        const thumbRect = thumb.getBoundingClientRect();
        const direction = event.clientY < thumbRect.top ? -1 : 1;
        scrollport.scrollBy({
            top: direction * scrollport.clientHeight * 0.9,
            behavior: 'smooth',
        });
    });

    scrollport.addEventListener('scroll', scheduleUpdate, {passive: true});
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('pageshow', scheduleUpdate);

    if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(scheduleUpdate);
        resizeObserver.observe(scrollport);
        Array.from(scrollport.children).forEach((child) => resizeObserver.observe(child));
    }

    if ('MutationObserver' in window) {
        const mutationObserver = new MutationObserver(scheduleUpdate);
        mutationObserver.observe(root, {attributes: true, attributeFilter: ['class']});
    }

    update();
}
